import { 
    getAuth, 
    signInWithEmailAndPassword, 
    signOut,
    onAuthStateChanged 
  } from 'firebase/auth';
  import { doc, getDoc } from 'firebase/firestore';
  import { db } from './config';
  
  const auth = getAuth();
  
  export const authService = {
    // Login
    login: async (email, password) => {
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        
        // Obtener rol del usuario desde Firestore
        const userDoc = await getDoc(doc(db, 'users', userCredential.user.uid));
        const userData = userDoc.data();
        
        if (!userData) {
          throw new Error('Usuario no encontrado en la base de datos');
        }
  
        return {
          uid: userCredential.user.uid,
          email: userCredential.user.email,
          role: userData.role
        };
      } catch (error) {
        console.error('Error en login:', error);
        throw error;
      }
    },
  
    // Logout
    logout: async () => {
      try {
        await signOut(auth);
      } catch (error) {
        console.error('Error en logout:', error);
        throw error;
      }
    },
  
    // Verificar el estado de autenticación
    getCurrentUser: () => {
      return new Promise((resolve, reject) => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
          unsubscribe();
          if (user) {
            try {
              const userDoc = await getDoc(doc(db, 'users', user.uid));
              const userData = userDoc.data();
              resolve({
                uid: user.uid,
                email: user.email,
                role: userData?.role
              });
            } catch (error) {
              reject(error);
            }
          } else {
            resolve(null);
          }
        }, reject);
      });
    }
  };